var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPower = function SvgPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "power_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgPower as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTguMzYwMSA2LjY0MDAxQzE5LjYxODUgNy44OTg4IDIwLjQ3NTQgOS41MDI0NiAyMC44MjI0IDExLjI0ODJDMjEuMTY5NCAxMi45OTQgMjAuOTkxIDE0LjgwMzQgMjAuMzA5OCAxNi40NDc4QzE5LjYyODUgMTguMDkyMSAxOC40NzQ5IDE5LjQ5NzYgMTYuOTk0OSAyMC40ODY0QzE1LjUxNSAyMS40NzUyIDEzLjc3NSAyMi4wMDI5IDExLjk5NTEgMjIuMDAyOUMxMC4yMTUyIDIyLjAwMjkgOC40NzUyNyAyMS40NzUyIDYuOTk1MjkgMjAuNDg2NEM1LjUxNTMyIDE5LjQ5NzYgNC4zNjE3NiAxOC4wOTIxIDMuNjgwNDkgMTYuNDQ3OEMyLjk5OTIxIDE0LjgwMzQgMi44MjA4MSAxMi45OTQgMy4xNjc4NCAxMS4yNDgyQzMuNTE0ODcgOS41MDI0NiA0LjM3MTc0IDcuODk4OCA1LjYzMDEyIDYuNjQwMDEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xMiAyVjEyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";